import { useContext } from 'react';
import { AppBar, Button, Stack, Toolbar, Tooltip } from '@mui/material';
import {
  useAssociateStore,
  UpdateAssociateAvailabilityButton,
} from '@vs-online-only-app/ui';
import {
  AssociateApprovalStatus,
  AuthenticationContext,
  AssociateSetupContext,
} from '@vs-online-only-app/state';
import { AssociateDetails } from './AssociateDetails';
import AppLogo from './AppLogo';
import HelpMenu from './HelpMenu';

const isStandalone = window.top === window;

const TopBar = () => {
  const { user, isAuthenticated, logout } = useContext(AuthenticationContext);
  const { hasCompletedProfileSetup, hasCompletedIntroModules, associateSetupState } = useContext(
    AssociateSetupContext,
  );
  const { isStoreOpen, formattedTimeUntilStoreOpens } = useAssociateStore(user);

  const retailerName = associateSetupState?.retailer?.name;

  const isAssociateApplicationApproved =
    user?.approvalStatus === AssociateApprovalStatus.Approved;

  const hasCompletedSetup =
    hasCompletedProfileSetup && hasCompletedIntroModules;

  return (
    <AppBar
      position="relative"
      elevation={0}
      sx={(theme) => ({
        background:
          theme.palette.background[
            isAuthenticated && hasCompletedSetup ? 'default' : 'paper'
          ],
        borderBottom: 1,
        borderColor: 'divider',
      })}
    >
      <Toolbar sx={{ justifyContent: isStandalone ? 'space-between' : 'end' }}>
        {isStandalone && <AppLogo retailerName={retailerName} />}
        <Stack direction="row" gap={2} alignItems="center">
          {isStandalone && <HelpMenu />}
          {isAuthenticated && (
            <Tooltip
              arrow
              title={
                isAssociateApplicationApproved &&
                !isStoreOpen && (
                  <>
                    Your store will open in{' '}
                    <strong>{formattedTimeUntilStoreOpens}</strong>. Then you
                    can go online and start chatting with customers.
                  </>
                )
              }
            >
              <div>
                <UpdateAssociateAvailabilityButton
                  associate={user}
                  variant="contained"
                  disabled={!isStoreOpen}
                />
              </div>
            </Tooltip>
          )}
          {isAuthenticated && hasCompletedSetup && isStandalone && <AssociateDetails />}
          {isAuthenticated && !hasCompletedSetup && isStandalone && (
            <Button
              disableElevation
              variant="contained"
              color="secondary"
              onClick={() => logout()}
            >
              Log out
            </Button>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
